module.exports = __webpack_public_path__ + "img/1481714534.83cb67cc.jpg";